import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/transnetBW/tng-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3f958372"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-3xl md:text-3xl" }, "Checkliste BE Flächen"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      width: "200"
    })
  ])
], -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "h-full max-h-full" }
const _hoisted_6 = { class: "grid grid-cols-8 justify-items-stretch items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Vorhaben", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Aufnahmedaten", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Mast-Foto", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Vorhaben:", -1))
const _hoisted_11 = { class: "text-gray-500 col-span-2 text-xs" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "BearbeiterIn:", -1))
const _hoisted_13 = { class: "text-gray-500 text-xs col-span-2" }
const _hoisted_14 = {
  key: 0,
  class: "mt-2 row-span-5 col-span-2"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "row-span-5 col-span-2 flex item-stretch justify-center items-center mt-2 no-pic"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center self-center" }, "Kein Bild hinzugefügt", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Anlage:", -1))
const _hoisted_20 = { class: "text-gray-500 text-xs col-span-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Firma:", -1))
const _hoisted_22 = { class: "text-gray-500 col-span-2 text-xs" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Mastnr:", -1))
const _hoisted_24 = { class: "text-gray-500 text-xs col-span-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2" }, "Begehungsdatum:", -1))
const _hoisted_26 = { class: "text-gray-500 text-xs" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, " Masttyp: ", -1))
const _hoisted_28 = { class: "text-gray-500 text-xs col-span-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2 col-span-2" }, "Aktualisierungsdatum:", -1))
const _hoisted_30 = { class: "text-gray-500 text-xs" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Höhe:", -1))
const _hoisted_32 = { class: "text-gray-500 text-xs col-span-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2" }, "Bearbeitungsstatus:", -1))
const _hoisted_34 = { class: "text-gray-500 text-xs col-span-1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Mastbild:", -1))
const _hoisted_36 = { class: "text-gray-500 text-xs col-span-7" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Gestängetyp:", -1))
const _hoisted_38 = { class: "text-gray-500 text-xs col-span-7" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2 col-span-2 mt-3" }, " Baumaßnahme Art: ", -1))
const _hoisted_40 = { class: "text-gray-500 text-xs col-span-6 mt-3" }
const _hoisted_41 = { class: "text-xs col-span-2 text-gray-500 mt-3" }
const _hoisted_42 = { class: "text-xs col-span-3 text-gray-500 mt-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-1 ml-2 mt-3" }, "Art:", -1))
const _hoisted_44 = { class: "text-xs col-span-7 mt-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2 col-span-2 mt-3" }, "Unterzeichnet von:", -1))
const _hoisted_46 = { class: "text-xs col-span-4 row-span-2 mb-10 mt-3" }
const _hoisted_47 = { class: "col-span-3 text-gray-500 row-span-1" }
const _hoisted_48 = {
  key: 0,
  class: "h-2 text-xs col-span-3"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 1,
  class: "h-2 text-xs ml-2 col-span-3 flex item-stretch justify-center items-center",
  style: {"height":"50px","max-height":"50px","background-color":"rgb(235, 239, 240)","border-radius":"5px","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                      rgb(235, 239, 240) rgb(235, 239, 240)"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center self-center" }, "keine Unterschrift hinzugefügt", -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "mt-6 flex justify-between border-solid rounded-md whiteYellowBorderColor" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Gesamt-Bewertung", -1))
const _hoisted_55 = { class: "mt-2 ml-2 text-xs" }
const _hoisted_56 = { class: "text-xs text-gray-500" }
const _hoisted_57 = { class: "mt-6 flex justify-between border-solid rounded-md whiteYellowBorderColor" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Arbeitsfläche", -1))
const _hoisted_59 = {
  key: 0,
  class: "place-self-center"
}
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "p-2 grid grid-cols-8 gap-1 justify-item-stretch" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-1" }, "Allgemeine Punkte:", -1))
const _hoisted_63 = { class: "justify-self-end" }
const _hoisted_64 = { class: "justify-self-end" }
const _hoisted_65 = { class: "justify-self-end" }
const _hoisted_66 = { class: "justify-self-end" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-1" }, "Geländebeschaffenheit:", -1))
const _hoisted_68 = { class: "justify-self-end" }
const _hoisted_69 = { class: "justify-self-end" }
const _hoisted_70 = { class: "justify-self-end" }
const _hoisted_71 = { class: "justify-self-end" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-1" }, "Ökologie:", -1))
const _hoisted_73 = { class: "justify-self-end" }
const _hoisted_74 = { class: "justify-self-end" }
const _hoisted_75 = { class: "justify-self-end" }
const _hoisted_76 = { class: "justify-self-end" }
const _hoisted_77 = { class: "flex justify-between border-solid rounded-md whiteYellowBorderColor" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Zuwegung", -1))
const _hoisted_79 = {
  key: 0,
  class: "place-self-center"
}
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "p-2 grid grid-cols-8 gap-2 w-fit" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-2" }, "Allgemeine Punkte:", -1))
const _hoisted_83 = { class: "justify-self-end" }
const _hoisted_84 = { class: "justify-self-end" }
const _hoisted_85 = { class: "justify-self-end" }
const _hoisted_86 = { class: "justify-self-end" }
const _hoisted_87 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_88 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-3xl md:text-3xl" }, "Checkliste BE Flächen"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      width: "200"
    })
  ])
], -1))
const _hoisted_90 = { class: "content" }
const _hoisted_91 = { class: "h-full max-h-full" }
const _hoisted_92 = {
  class: "mt-6 flex justify-between",
  style: {"border-style":"solid","border-color":"white white rgb(216, 215, 26) white","border-radius":"5px"}
}
const _hoisted_93 = { class: "text-lg md:text-lg" }
const _hoisted_94 = { class: "text-xs" }
const _hoisted_95 = { class: "text-xs" }
const _hoisted_96 = { class: "justify-self-end" }
const _hoisted_97 = { class: "p-2 grid grid-cols-8 gap-1 justify-item-stretch" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-1" }, "Seilzugfläche:", -1))
const _hoisted_99 = { class: "justify-self-end" }
const _hoisted_100 = { class: "justify-self-end" }
const _hoisted_101 = { class: "justify-self-end" }
const _hoisted_102 = { class: "justify-self-end" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-1" }, " Zuwegung Seilzugfläche: ", -1))
const _hoisted_104 = { style: {"display":"contents"} }
const _hoisted_105 = { class: "justify-self-end" }
const _hoisted_106 = { class: "justify-self-end" }
const _hoisted_107 = { class: "justify-self-end" }
const _hoisted_108 = { class: "justify-self-end" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-1" }, "Fläche zwischen Mast und Seilzugfläche:", -1))
const _hoisted_110 = { class: "justify-self-end" }
const _hoisted_111 = { class: "justify-self-end" }
const _hoisted_112 = { class: "justify-self-end" }
const _hoisted_113 = { class: "justify-self-end" }
const _hoisted_114 = { class: "flex justify-between border-solid rounded-md whiteYellowBorderColor" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Schutzgerüste", -1))
const _hoisted_116 = { class: "col-span-2 ml-2 text-sm" }
const _hoisted_117 = { class: "place-self-center col-span-2 text-xs" }
const _hoisted_118 = { class: "justify-self-end" }
const _hoisted_119 = { class: "justify-self-end" }
const _hoisted_120 = { class: "justify-self-end" }
const _hoisted_121 = { class: "justify-self-end" }
const _hoisted_122 = { class: "flex justify-between border-solid rounded-md whiteYellowBorderColor" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Fremdleitungen", -1))
const _hoisted_124 = { class: "p-2 grid grid-cols-8 gap-2 w-fit" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 ml-2 text-sm" }, "Fremdleitungen:", -1))
const _hoisted_126 = { class: "justify-self-end" }
const _hoisted_127 = { class: "justify-self-end" }
const _hoisted_128 = { class: "justify-self-end" }
const _hoisted_129 = { class: "justify-self-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.vorhaben')?.['eingabeText']), 1),
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.bearbeiter')?.['eingabeText']), 1),
                  (_ctx.getPhotoUrl(_ctx.immobilie?.vorschaubild))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("img", {
                          src: _ctx.getPhotoUrl(_ctx.immobilie?.vorschaubild),
                          style: {"max-height":"150px"},
                          height: "150",
                          width: "180",
                          "data-cy": "generalData-vorschaubild"
                        }, null, 8, _hoisted_15)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.anlage')?.['eingabeText']), 1),
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-fleachen.allgemein-tab.allgemein-group.firma')?.['eingabeText']), 1),
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.mastnummer')?.['eingabeText']), 1),
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.moment(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.begehungsdatum')?.['eingabeText'] || "").isValid() 
                  ? _ctx.moment(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.begehungsdatum')?.['eingabeText']).format('DD-MM-YYYY') 
                  : ""), 1),
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.masttyp')), 1),
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.ba?.updatedAt ? _ctx.moment(_ctx.ba.updatedAt).format('DD-MM-YYYY') : ""), 1),
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.masthoehe')?.['eingabeText'] ? _ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.masthoehe')?.['eingabeText'] + " m" : "-"), 1),
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.statusReadable), 1),
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.mastbild')), 1),
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.gestaengetyp')?.['eingabeText']), 1),
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba,'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.baumassnahmeart')), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.seilzug-vorhanden",
                    label: "Seilzug vorhanden",
                    class: "col-span-8 ml-2 mt-3"
                  }, null, 8, ["ba"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.sonstiges-vorhanden",
                    label: "Sonstiges:",
                    class: "text-xs ml-2 mt-3"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.sonstiges-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-vorhanden",
                    label: "Zusätzliche Maßnahmen:",
                    class: "col-span-2 ml-2 mt-3"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-beschreibung')?.['eingabeText']), 1),
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-art')?.getSelectedAuswahlLabels(), (v, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v.de), 1))
                    }), 128))
                  ]),
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.ba?.unterschrifts?.[0]?.name || ''), 1),
                    (_ctx.ba?.unterschrifts?.[0]?.bild && _ctx.getPhotoUrl(_ctx.ba.unterschrifts[0].bild))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("img", {
                            src: _ctx.getPhotoUrl(_ctx.ba?.unterschrifts[0].bild),
                            style: {"max-height":"50px","max-width":"180px","background":"#efefef"},
                            height: "50",
                            width: "180"
                          }, null, 8, _hoisted_49)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", null, [
                    _createVNode(_component_PdfChip, {
                      color: _ctx.colorOverall,
                      "mangel-amount-mode": "",
                      value: _ctx.amountOverall,
                      "pdf-mode": ""
                    }, null, 8, ["color", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createTextVNode(" Bewertung der BearbeiterIn: "),
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.ba?.fazit), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  (_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.ergebnis-group.ergebnisbauflaechen')?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba,'tng-be-flaechen.arbeitsflaeche-mast-tab.ergebnis-group.ergebnisbauflaechen')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_60, "keine Bewertung bisher")),
                  _createElementVNode("div", null, [
                    _createVNode(_component_PdfChip, {
                      color: _ctx.colorArbeitsFlaechen,
                      "mangel-amount-mode": "",
                      value: _ctx.amountArbeitsFlaechen,
                      big: "",
                      "pdf-mode": ""
                    }, null, 8, ["color", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_PdfChip, {
                      color: "green",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['allgemein']
                    )?.filter((f) => f === 'plus')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_PdfChip, {
                      color: "blue",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['allgemein']
                    )?.filter((f) => f === 'o')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createVNode(_component_PdfChip, {
                      color: "yellow",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['allgemein']
                    )?.filter((f) => f === 'minus')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_PdfChip, {
                      color: "red",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['allgemein']
                    )?.filter((f) => f === 'x')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _hoisted_67,
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_PdfChip, {
                      color: "green",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['gelaende']
                    )?.filter((f) => f === 'plus')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_PdfChip, {
                      color: "blue",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['gelaende']
                    )?.filter((f) => f === 'o')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_PdfChip, {
                      color: "yellow",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['gelaende']
                    )?.filter((f) => f === 'minus')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_PdfChip, {
                      color: "red",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['gelaende']
                    )?.filter((f) => f === 'x')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, [
                    _createVNode(_component_PdfChip, {
                      color: "green",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['oekologie']
                    )?.filter((f) => f === 'plus')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createVNode(_component_PdfChip, {
                      color: "blue",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['oekologie']
                    )?.filter((f) => f === 'o')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createVNode(_component_PdfChip, {
                      color: "yellow",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['oekologie']
                    )?.filter((f) => f === 'minus')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createVNode(_component_PdfChip, {
                      color: "red",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(
                      _ctx.getArbeitsFlaecheBewertungen(_ctx.ba)['oekologie']
                    )?.filter((f) => f === 'x')?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("div", null, [
                    (_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.ergebnis-group.ergebniszuwegung')?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.zuwegung-mast-tab.ergebnis-group.ergebniszuwegung')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_80, "keine Bewertung bisher"))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_PdfChip, {
                      color: _ctx.colorZuwegung,
                      "mangel-amount-mode": "",
                      value: _ctx.amountZuwegung,
                      big: "",
                      "pdf-mode": ""
                    }, null, 8, ["color", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _hoisted_82,
                  _createElementVNode("div", _hoisted_83, [
                    _createVNode(_component_PdfChip, {
                      color: "green",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getZuwegungBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_PdfChip, {
                      color: "blue",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getZuwegungBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_PdfChip, {
                      color: "yellow",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getZuwegungBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createVNode(_component_PdfChip, {
                      color: "red",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getZuwegungBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: ""
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSeilzugflaechen(_ctx.ba), (seilzugflaeche, szfKey) => {
                  return (_openBlock(), _createElementBlock("div", { key: szfKey }, [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, "Seilzugfläche " + _toDisplayString(szfKey + 1), 1),
                      _createElementVNode("div", _hoisted_94, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'ergebnis-modal.ergebnis.seilzugflaeche')?.getSelectedAuswahlLabelsString()), 1),
                      _createElementVNode("div", _hoisted_95, "Zuwegung " + _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'ergebnis-modal.ergebnis.ergebniszuwegung')?.getSelectedAuswahlLabelsString()), 1),
                      _createElementVNode("div", _hoisted_96, [
                        _createVNode(_component_PdfChip, {
                          color: _ctx.summarizeSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['color'],
                          "mangel-amount-mode": "",
                          value: _ctx.summarizeSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['amount'],
                          "pdf-mode": ""
                        }, null, 8, ["color", "value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      _hoisted_98,
                      _createElementVNode("div", _hoisted_99, [
                        _createVNode(_component_PdfChip, {
                          color: "green",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'plus';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _createVNode(_component_PdfChip, {
                          color: "blue",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'o';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _createVNode(_component_PdfChip, {
                          color: "yellow",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'minus';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_PdfChip, {
                          color: "red",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'x';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ]),
                      _hoisted_103,
                      _createElementVNode("span", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, [
                          _createVNode(_component_PdfChip, {
                            color: "green",
                            "mangel-amount-mode": "",
                            value: 
                        Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'plus';
                          })?.length
                      ,
                            "pdf-mode": ""
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _createVNode(_component_PdfChip, {
                            color: "blue",
                            "mangel-amount-mode": "",
                            value: 
                        Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'o';
                          })?.length
                      ,
                            "pdf-mode": ""
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_107, [
                          _createVNode(_component_PdfChip, {
                            color: "yellow",
                            "mangel-amount-mode": "",
                            value: 
                        Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'minus';
                          })?.length
                      ,
                            "pdf-mode": ""
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _createVNode(_component_PdfChip, {
                            color: "red",
                            "mangel-amount-mode": "",
                            value: 
                        Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'x';
                          })?.length
                      ,
                            "pdf-mode": ""
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _hoisted_109,
                      _createElementVNode("div", _hoisted_110, [
                        _createVNode(_component_PdfChip, {
                          color: "green",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'plus';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_111, [
                        _createVNode(_component_PdfChip, {
                          color: "blue",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'o';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_112, [
                        _createVNode(_component_PdfChip, {
                          color: "yellow",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'minus';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_113, [
                        _createVNode(_component_PdfChip, {
                          color: "red",
                          "mangel-amount-mode": "",
                          value: 
                      Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'x';
                        })?.length
                    ,
                          "pdf-mode": ""
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_114, [
                  _hoisted_115,
                  _createElementVNode("div", null, [
                    _createVNode(_component_PdfChip, {
                      color: _ctx.colorSchutzgerueste,
                      "mangel-amount-mode": "",
                      value: _ctx.amountSchutzgerueste,
                      big: "",
                      "pdf-mode": ""
                    }, null, 8, ["color", "value"])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSchutzgerueste(_ctx.ba), (schutzgeruest, szgKey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "p-2 grid grid-cols-8 gap-2 w-fit",
                    key: szgKey
                  }, [
                    _createElementVNode("div", _hoisted_116, "Schutzgerüst " + _toDisplayString(szgKey + 1), 1),
                    _createElementVNode("div", _hoisted_117, _toDisplayString(schutzgeruest.findFrageByRelativePath(_ctx.ba,'ergebnisschutzgeruest')?.getSelectedAuswahlLabelsString()), 1),
                    _createElementVNode("div", _hoisted_118, [
                      _createVNode(_component_PdfChip, {
                        color: "green",
                        "mangel-amount-mode": "",
                        value: 
                      Object?.values(_ctx.getSchutzgeruestBewertungen(_ctx.ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'plus';
                        })?.length
                    ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _createVNode(_component_PdfChip, {
                        color: "blue",
                        "mangel-amount-mode": "",
                        value: 
                      Object?.values(_ctx.getSchutzgeruestBewertungen(_ctx.ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'o';
                        })?.length
                    ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_120, [
                      _createVNode(_component_PdfChip, {
                        color: "yellow",
                        "mangel-amount-mode": "",
                        value: 
                      Object?.values(_ctx.getSchutzgeruestBewertungen(_ctx.ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'minus';
                        })?.length
                    ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_121, [
                      _createVNode(_component_PdfChip, {
                        color: "red",
                        "mangel-amount-mode": "",
                        value: 
                      Object?.values(_ctx.getSchutzgeruestBewertungen(_ctx.ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'x';
                        })?.length
                    ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_122, [
                  _hoisted_123,
                  _createElementVNode("div", null, [
                    _createVNode(_component_PdfChip, {
                      color: _ctx.colorFremdleitung,
                      "mangel-amount-mode": "",
                      value: _ctx.amountFremdleitung,
                      big: "",
                      "pdf-mode": ""
                    }, null, 8, ["color", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_124, [
                  _hoisted_125,
                  _createElementVNode("div", _hoisted_126, [
                    _createVNode(_component_PdfChip, {
                      color: "green",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_127, [
                    _createVNode(_component_PdfChip, {
                      color: "blue",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_128, [
                    _createVNode(_component_PdfChip, {
                      color: "yellow",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _createVNode(_component_PdfChip, {
                      color: "red",
                      "mangel-amount-mode": "",
                      value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  ,
                      "pdf-mode": ""
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: ""
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"])
  ], 64))
}